// extracted by mini-css-extract-plugin
module.exports = {"btnIcon":"button-icon_btnIcon__TuJSN","btnIconText":"button-icon_btnIconText__eQRbW"};